export const PORTFOLIO_POLICY_RULE_IDS_V2 = [
  "TV-P35-POL-RULE-001", "TV-P35-POL-RULE-002", "TV-P35-POL-RULE-003", "TV-P35-POL-RULE-004",
  "TV-P35-POL-RULE-005", "TV-P35-POL-RULE-006", "TV-P35-POL-RULE-007", "TV-P35-POL-RULE-008",
  "TV-P35-POL-RULE-009", "TV-P35-POL-RULE-010", "TV-P35-POL-RULE-011", "TV-P35-POL-RULE-012",
  "TV-P35-POL-RULE-013", "TV-P35-POL-RULE-014", "TV-P35-POL-RULE-015", "TV-P35-POL-RULE-016",
  "TV-P35-POL-RULE-017", "TV-P35-POL-RULE-018", "TV-P35-POL-RULE-019", "TV-P35-POL-RULE-020",
  "TV-P35-POL-RULE-021", "TV-P35-POL-RULE-022", "TV-P35-POL-RULE-023", "TV-P35-POL-RULE-024",
] as const;
export type PortfolioPolicyRuleIdV2 = typeof PORTFOLIO_POLICY_RULE_IDS_V2[number];
